import { Proteins } from 'models/Pet';

export const getProteinFromSlug = (slug: string): Proteins | null => {
    const parts: string[] = slug.split('-');
    
    const protein = parts.find((part) => Object.values(Proteins).includes(part.toUpperCase() as Proteins))

    if (!protein) return null

    return protein.toUpperCase() as Proteins
}